// "Remove building" (DD, 2026-10-26): only an empty building, never the job's
// last, and only once it has synced; needs signal and asks first. CRM retires it
// (it can be restored there). Areas are moved or removed first, so nothing
// measured goes with one tap.
import { ApiError, isConnectionFailure } from '../lib/api';
import { buildingName, buildingRemovalBlock } from '../lib/buildings';
import type { DeviceRecord } from '../lib/device-db';
import { useOnline } from '../lib/hooks';
import { ServerRemoveButton } from './remove-button';

interface Props {
  building: DeviceRecord;
  records: readonly DeviceRecord[];
  /** Removes it (CRM, then this device); the caller moves off it. */
  onRemove: () => Promise<void>;
  /** Why a removal was refused (null to clear), shown by the caller under its buttons. */
  onError: (message: string | null) => void;
}

const describe = (err: unknown): string =>
  isConnectionFailure(err) ? 'Removing a building needs signal.' : err instanceof ApiError ? err.message : 'The building could not be removed.';

export function RemoveBuilding({ building, records, onRemove, onError }: Props) {
  const online = useOnline();
  const blocked = buildingRemovalBlock(building, records, online);
  return (
    <>
      <ServerRemoveButton
        label="Remove building"
        blocked={blocked}
        question={
          <>
            Remove <strong>{buildingName(building)}</strong> from this job? It has no areas, so nothing measured goes with it.
          </>
        }
        onRemove={onRemove}
        onError={onError}
        describe={describe}
      />
      {blocked && <span className="w-full text-right text-xs text-slate-500">{blocked}</span>}
    </>
  );
}
